import React from 'react';



 class CircularIndeterminate extends React.Component {
  render(){
    return(
        <div>
          <div class="loading-spinner"></div>
        </div>
      )
  }

 }



export default CircularIndeterminate;